var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35193 9.20096C1.63719 9.99922 1.62181 11.2036 2.27778 12.0508C3.57949 13.732 5.00422 15.1567 6.68543 16.4584C7.53264 17.1144 8.73699 17.099 9.53524 16.3843C11.7025 14.4437 13.6873 12.4157 15.6028 10.1871C15.7921 9.96674 15.9106 9.69669 15.9372 9.40737C16.0547 8.12798 16.2962 4.44199 15.2952 3.44098C14.2942 2.43997 10.6082 2.68147 9.32883 2.79903C9.03952 2.82562 8.76946 2.94407 8.54913 3.13344C6.32048 5.04889 4.29248 7.03367 2.35193 9.20096Z",
    stroke: "#383C42",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92529 11.3109L7.42529 12.8109",
    stroke: "#383C42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8003 4.93591L16.8003 1.93591",
    stroke: "#383C42",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponIcon);
export default __webpack_public_path__ + "static/media/coupon-icon.4a2e57a2241aabd1770798ea20d5677c.svg";
export { ForwardRef as ReactComponent };